export default {
  header: {
    self: {},
    items: []
  },
  aside: {
    self: {},
    items: [
      {
        title: 'Home',
        root: true,
        icon: 'flaticon2-architecture-and-city',
        page: 'home',
        translate: 'menu.home.title',
        bullet: 'line'
      },
      {
        title: 'Dashboard',
        root: true,
        icon: 'flaticon-line-graph',
        page: 'dashboard',
        translate: 'menu.dashboard.title',
        bullet: 'line'
      },
      {
        title: 'Demo',
        root: true,
        icon: 'flaticon2-start-up',
        translate: 'menu.demo.title',
        bullet: 'line',
        submenu: [
          {
            title: 'Demo List',
            bullet: 'line',
            page: 'demo/list',
            translate: 'menu.demo.list.title'
          },
          {
            title: 'Demo Report',
            bullet: 'line',
            page: 'demo/Report',
            translate: 'menu.demo.report.title'
          },
          {
            title: 'Demo Create',
            bullet: 'line',
            page: 'demo/new',
            translate: 'menu.demo.create.title',
            hidden: true // crud title and breadcrums
          },
          {
            title: 'Demo Edit',
            bullet: 'line',
            page: 'demo/edit',
            translate: 'menu.demo.edit.title',
            hidden: true // crud title and breadcrums
          }
          // Default menu generated by battlecry
        ]
      },
      { section: 'Main' },
      {
        title: 'Sale Management',
        root: true,
        bullet: 'line',
        icon: 'flaticon2-browser-2',
        translate: 'menu.sale.data.management.title',
        submenu: [
          {
            title: 'PosSale',
            page: 'common/pos_sales',
            translate: 'menu.common.pos_sale.title'
          },
          {
            title: 'PosSale Create',
            page: 'common/pos_sales/:id/new',
            translate: 'menu.common.pos_sale.create.title',
            hidden: true
          },
          {
            title: 'PosSale Edit',
            page: 'common/pos_sales/:id/edit',
            translate: 'menu.common.pos_sale.edit.title',
            hidden: true
          }
        ]
      },
      {
        title: 'Base Data Management',
        root: true,
        bullet: 'line',
        icon: 'flaticon2-browser-2',
        translate: 'menu.base.data.title',
        submenu: [
          {
            title: 'Organization Management',
            bullet: 'line',
            translate: 'menu.base.organization.title',
            submenu: [

              {
                title: 'Company',
                page: 'common/companies',
                translate: 'menu.common.company.title'
              },
              {
                title: 'Department',
                page: 'common/departments',
                translate: 'menu.common.department.title'
              },
              {
                title: 'Department Create',
                page: 'common/departments/:id/new',
                translate: 'menu.common.department.create.title',
                hidden: true
              },
              {
                title: 'Department Edit',
                page: 'common/departments/:id/edit',
                translate: 'menu.common.department.edit.title',
                hidden: true
              },
              {
                title: 'Store',
                page: 'common/stores',
                translate: 'menu.common.store.title'
              },
              {
                title: 'Store Create',
                page: 'common/stores/:id/new',
                translate: 'menu.common.store.create.title',
                hidden: true
              },
              {
                title: 'Store Edit',
                page: 'common/stores/:id/edit',
                translate: 'menu.common.store.edit.title',
                hidden: true
              },
              {
                title: 'PosFloor',
                page: 'common/pos_floors',
                translate: 'menu.common.pos_floor.title'
              },
              {
                title: 'PosFloor Create',
                page: 'common/pos_floors/:id/new',
                translate: 'menu.common.pos_floor.create.title',
                hidden: true
              },
              {
                title: 'PosFloor Edit',
                page: 'common/pos_floors/:id/edit',
                translate: 'menu.common.pos_floor.edit.title',
                hidden: true
              },
              {
                title: 'PosFloor Layout',
                page: 'common/pos_floors/:id/layout',
                translate: 'menu.common.pos_floor.layout.title',
                hidden: true
              },
              {
                title: 'PosTable',
                page: 'common/pos_tables',
                translate: 'menu.common.pos_table.title'
              },
              {
                title: 'PosTable Create',
                page: 'common/pos_tables/:id/new',
                translate: 'menu.common.pos_table.create.title',
                hidden: true
              },
              {
                title: 'PosTable Edit',
                page: 'common/pos_tables/:id/edit',
                translate: 'menu.common.pos_table.edit.title',
                hidden: true
              },
              {
                title: 'Service',
                page: 'common/services',
                translate: 'menu.common.service.title'
              },
              {
                title: 'Service Create',
                page: 'common/services/:id/new',
                translate: 'menu.common.service.create.title',
                hidden: true
              },
              {
                title: 'Service Edit',
                page: 'common/services/:id/edit',
                translate: 'menu.common.service.edit.title',
                hidden: true
              },
              {
                title: 'Branch',
                page: 'common/branches',
                translate: 'menu.common.branch.title'
              },
              {
                title: 'Branch Create',
                page: 'common/branches/:id/new',
                translate: 'menu.common.branch.create.title',
                hidden: true
              },
              {
                title: 'Branch Edit',
                page: 'common/branches/:id/edit',
                translate: 'menu.common.branch.edit.title',
                hidden: true
              }
            ]
          },
          {
            title: 'User Management',
            bullet: 'line',
            translate: 'menu.base.user.title',
            submenu: [
              {
                title: 'User',
                page: 'common/users',
                translate: 'menu.common.user.title'
              },
              {
                title: 'User Create',
                page: 'common/users/:id/new',
                translate: 'menu.common.user.create.title',
                hidden: true
              },
              {
                title: 'User Edit',
                page: 'common/users/:id/edit',
                translate: 'menu.common.user.edit.title',
                hidden: true
              },
              {
                title: 'Employee',
                page: 'common/employees',
                translate: 'menu.common.employee.title'
              },
              {
                title: 'Employee Create',
                page: 'common/employees/:id/new',
                translate: 'menu.common.employee.create.title',
                hidden: true
              },
              {
                title: 'Employee Edit',
                page: 'common/employees/:id/edit',
                translate: 'menu.common.employee.edit.title',
                hidden: true
              }
            ]
          },
          {
            title: 'Pos Management',
            bullet: 'line',
            translate: 'menu.base.pos.title',
            submenu: [
              {
                title: 'PosInfo',
                page: 'common/pos_infos',
                translate: 'menu.common.pos_info.title'
              },
              {
                title: 'PosInfo Create',
                page: 'common/pos_infos/:id/new',
                translate: 'menu.common.pos_info.create.title',
                hidden: true
              },
              {
                title: 'PosInfo Edit',
                page: 'common/pos_infos/:id/edit',
                translate: 'menu.common.pos_info.edit.title',
                hidden: true
              }
            ]
          },
          {
            title: 'Invoice Management',
            bullet: 'line',
            translate: 'menu.base.invoice.title',
            submenu: [
              {
                title: 'InvoiceSet',
                page: 'common/invoice_sets',
                translate: 'menu.common.invoice_set.title'
              },
              {
                title: 'InvoiceSet Create',
                page: 'common/invoice_sets/:id/new',
                translate: 'menu.common.invoice_set.create.title',
                hidden: true
              },
              {
                title: 'InvoiceSet Edit',
                page: 'common/invoice_sets/:id/edit',
                translate: 'menu.common.invoice_set.edit.title',
                hidden: true
              },
              {
                title: 'InvoiceSource',
                page: 'common/invoice_sources',
                translate: 'menu.common.invoice_source.title'
              },
              {
                title: 'InvoiceSource Create',
                page: 'common/invoice_sources/:id/new',
                translate: 'menu.common.invoice_source.create.title',
                hidden: true
              },
              {
                title: 'InvoiceSource Edit',
                page: 'common/invoice_sources/:id/edit',
                translate: 'menu.common.invoice_source.edit.title',
                hidden: true
              }
            ]
          },
          {
            title: 'StockUnit',
            page: 'common/stock_units',
            translate: 'menu.common.stock_unit.title',
            hidden: true,
            submenu: [
              {
                title: 'TradeUnit',
                page: 'common/stock_units/:parent_id/trade_units',
                translate: 'menu.common.trade_unit.title',
                hidden: true
              },
              {
                title: 'TradeUnit Create',
                page: 'common/stock_units/:parent_id/trade_units/:id/new',
                translate: 'menu.common.trade_unit.create.title',
                hidden: true
              },
              {
                title: 'TradeUnit Edit',
                page: 'common/stock_units/:parent_id/trade_units/:id/edit',
                translate: 'menu.common.trade_unit.edit.title',
                hidden: true
              }
            ]
          },
          {
            title: 'StockUnit',
            page: 'common/stock_units',
            translate: 'menu.common.stock_unit.title'
          },
          {
            title: 'StockUnit Create',
            page: 'common/stock_units/:id/new',
            translate: 'menu.common.stock_unit.create.title',
            hidden: true
          },
          {
            title: 'StockUnit Edit',
            page: 'common/stock_units/:id/edit',
            translate: 'menu.common.stock_unit.edit.title',
            hidden: true
          },
          {
            title: 'Member',
            page: 'common/members',
            translate: 'menu.common.member.title'
          },
          {
            title: 'Member Create',
            page: 'common/members/:id/new',
            translate: 'menu.common.member.create.title',
            hidden: true
          },
          {
            title: 'Member Edit',
            page: 'common/members/:id/edit',
            translate: 'menu.common.member.edit.title',
            hidden: true
          }
        ]
      },
      {
        title: 'Material Management',
        bullet: 'line',
        translate: 'menu.base.material.title',
        root: true,
        icon: 'flaticon2-browser-2',
        submenu: [
          {
            title: 'Material Category Management',
            bullet: 'line',
            translate: 'menu.base.material.category.title',
            submenu: [
              {
                title: 'MaterialMajorCategory',
                page: 'common/material_major_categories',
                translate: 'menu.common.material_major_category.title'
              },
              {
                title: 'MaterialMajorCategory Create',
                page: 'common/material_major_categories/:id/new',
                translate: 'menu.common.material_major_category.create.title',
                hidden: true
              },
              {
                title: 'MaterialMajorCategory Edit',
                page: 'common/material_major_categories/:id/edit',
                translate: 'menu.common.material_major_category.edit.title',
                hidden: true
              },
              {
                title: 'MaterialMediumCategory',
                page: 'common/material_medium_categories',
                translate: 'menu.common.material_medium_category.title'
              },
              {
                title: 'MaterialMediumCategory Create',
                page: 'common/material_medium_categories/:id/new',
                translate: 'menu.common.material_medium_category.create.title',
                hidden: true
              },
              {
                title: 'MaterialMediumCategory Edit',
                page: 'common/material_medium_categories/:id/edit',
                translate: 'menu.common.material_medium_category.edit.title',
                hidden: true
              },
              {
                title: 'MaterialMinorCategory',
                page: 'common/material_minor_categories',
                translate: 'menu.common.material_minor_category.title'
              },
              {
                title: 'MaterialMinorCategory Create',
                page: 'common/material_minor_categories/:id/new',
                translate: 'menu.common.material_minor_category.create.title',
                hidden: true
              },
              {
                title: 'MaterialMinorCategory Edit',
                page: 'common/material_minor_categories/:id/edit',
                translate: 'menu.common.material_minor_category.edit.title',
                hidden: true
              }
            ]
          },
          {
            title: 'Material Management',
            bullet: 'line',
            translate: 'menu.base.material.management.title',
            submenu: [
              {
                title: 'Material',
                page: 'common/materials',
                translate: 'menu.common.material.title'
              },
              {
                title: 'Material Create',
                page: 'common/materials/:id/new',
                translate: 'menu.common.material.create.title',
                hidden: true
              },
              {
                title: 'Material Edit',
                page: 'common/materials/:id/edit',
                translate: 'menu.common.material.edit.title',
                hidden: true
              }
            ]
          }
        ]
      },

      {
        title: 'Product Management',
        root: true,
        bullet: 'line',
        icon: 'flaticon2-browser-2',
        translate: 'menu.common.products.management.title',
        submenu: [

          {
            title: 'POS Category Management',
            bullet: 'line',
            translate: 'menu.common.pos.category.management.title',
            submenu: [
              {
                title: 'ProductDepartmentCategory',
                page: 'common/product_department_categories',
                translate: 'menu.common.product_department_category.title'
              },
              {
                title: 'ProductDepartmentCategory Create',
                page: 'common/product_department_categories/:id/new',
                translate: 'menu.common.product_department_category.create.title',
                hidden: true
              },
              {
                title: 'ProductDepartmentCategory Edit',
                page: 'common/product_department_categories/:id/edit',
                translate: 'menu.common.product_department_category.edit.title',
                hidden: true
              },
              {
                title: 'ProductMajorCategory',
                page: 'common/product_major_categories',
                translate: 'menu.common.product_major_category.title'
              },
              {
                title: 'ProductMajorCategory Create',
                page: 'common/product_major_categories/:id/new',
                translate: 'menu.common.product_major_category.create.title',
                hidden: true
              },
              {
                title: 'ProductMajorCategory Edit',
                page: 'common/product_major_categories/:id/edit',
                translate: 'menu.common.product_major_category.edit.title',
                hidden: true
              },
              {
                title: 'ProductMediumCategory',
                page: 'common/product_medium_categories',
                translate: 'menu.common.product_medium_category.title'
              },
              {
                title: 'ProductMediumCategory Create',
                page: 'common/product_medium_categories/:id/new',
                translate: 'menu.common.product_medium_category.create.title',
                hidden: true
              },
              {
                title: 'ProductMediumCategory Edit',
                page: 'common/product_medium_categories/:id/edit',
                translate: 'menu.common.product_medium_category.edit.title',
                hidden: true
              },
              {
                title: 'ProductMinorCategory',
                page: 'common/product_minor_categories',
                translate: 'menu.common.product_minor_category.title'
              },
              {
                title: 'ProductMinorCategory Create',
                page: 'common/product_minor_categories/:id/new',
                translate: 'menu.common.product_minor_category.create.title',
                hidden: true
              },
              {
                title: 'ProductMinorCategory Edit',
                page: 'common/product_minor_categories/:id/edit',
                translate: 'menu.common.product_minor_category.edit.title',
                hidden: true
              }

            ]
          },
          {
            title: 'Product Management',
            bullet: 'line',
            translate: 'menu.common.products.management.title',
            submenu: [
              {
                title: 'Product',
                page: 'common/products',
                translate: 'menu.common.product.title'
              },
              {
                title: 'Product Create',
                page: 'common/products/:id/new',
                translate: 'menu.common.product.create.title',
                hidden: true
              },
              {
                title: 'Product Edit',
                page: 'common/products/:id/edit',
                translate: 'menu.common.product.edit.title',
                hidden: true
              },
              {
                title: 'StoreProductPrice',
                page: 'common/store_product_prices',
                translate: 'menu.common.store_product_price.title'
              },
              {
                title: 'ProductBundleItem',
                page: 'common/product_bundle_items',
                translate: 'menu.common.product_bundle_item.title',
                hidden: true
              },
              {
                title: 'ProductBundleItem Create',
                page: 'common/product_bundle_items/:id/new',
                translate: 'menu.common.product_bundle_item.create.title',
                hidden: true
              },
              {
                title: 'ProductBundleItem Edit',
                page: 'common/product_bundle_items/:id/edit',
                translate: 'menu.common.product_bundle_item.edit.title',
                hidden: true
              },
              {
                title: 'ProductComponentItem',
                page: 'common/product_component_items',
                translate: 'menu.common.product_component_item.title',
                hidden: true
              },
              {
                title: 'ProductComponentItem Create',
                page: 'common/product_component_items/:id/new',
                translate: 'menu.common.product_component_item.create.title',
                hidden: true
              },
              {
                title: 'ProductComponentItem Edit',
                page: 'common/product_component_items/:id/edit',
                translate: 'menu.common.product_component_item.edit.title',
                hidden: true
              },
              {
                title: 'ProductSuite',
                page: 'common/product_suites',
                translate: 'menu.common.product_suite.title'
              },
              {
                title: 'ProductSuite Create',
                page: 'common/product_suites/:id/new',
                translate: 'menu.common.product_suite.create.title',
                hidden: true
              },
              {
                title: 'ProductSuite Edit',
                page: 'common/product_suites/:id/edit',
                translate: 'menu.common.product_suite.edit.title',
                hidden: true
              },
              {
                title: 'ProductSuiteItem',
                page: 'common/product_suite_items',
                translate: 'menu.common.product_suite_item.title',
                hidden: true
              },
              {
                title: 'ProductSuiteItem Create',
                page: 'common/product_suite_items/:id/new',
                translate: 'menu.common.product_suite_item.create.title',
                hidden: true
              },
              {
                title: 'ProductSuiteItem Edit',
                page: 'common/product_suite_items/:id/edit',
                translate: 'menu.common.product_suite_item.edit.title',
                hidden: true
              },
              {
                title: 'ProductSuiteFolder',
                page: 'common/product_suite_folders',
                translate: 'menu.common.product_suite_folder.title',
                hidden: true
              },
              {
                title: 'ProductSuiteFolder Create',
                page: 'common/product_suite_folders/:id/new',
                translate: 'menu.common.product_suite_folder.create.title',
                hidden: true
              },
              {
                title: 'ProductSuiteFolder Edit',
                page: 'common/product_suite_folders/:id/edit',
                translate: 'menu.common.product_suite_folder.edit.title',
                hidden: true
              },
              {
                title: 'SubscriptionPeriod',
                page: 'common/subscription_periods',
                translate: 'menu.common.subscription_period.title'
              },
              {
                title: 'SubscriptionPeriod Create',
                page: 'common/subscription_periods/:id/new',
                translate: 'menu.common.subscription_period.create.title',
                hidden: true
              },
              {
                title: 'SubscriptionPeriod Edit',
                page: 'common/subscription_periods/:id/edit',
                translate: 'menu.common.subscription_period.edit.title',
                hidden: true
              },
              {
                title: 'SubscriptionQuantity',
                page: 'common/subscription_quantities',
                translate: 'menu.common.subscription_quantity.title'
              },
              {
                title: 'SubscriptionQuantity Create',
                page: 'common/subscription_quantities/:id/new',
                translate: 'menu.common.subscription_quantity.create.title',
                hidden: true
              },
              {
                title: 'SubscriptionQuantity Edit',
                page: 'common/subscription_quantities/:id/edit',
                translate: 'menu.common.subscription_quantity.edit.title',
                hidden: true
              },
              {
                title: 'SubscriptionPeriodItem',
                page: 'common/subscription_period_items',
                translate: 'menu.common.subscription_period_item.title',
                hidden: true
              },
              {
                title: 'SubscriptionPeriodItem Create',
                page: 'common/subscription_period_items/:id/new',
                translate: 'menu.common.subscription_period_item.create.title',
                hidden: true
              },
              {
                title: 'SubscriptionPeriodItem Edit',
                page: 'common/subscription_period_items/:id/edit',
                translate: 'menu.common.subscription_period_item.edit.title',
                hidden: true
              },
              {
                title: 'SubscriptionQuantityItem',
                page: 'common/subscription_quantity_items',
                translate: 'menu.common.subscription_quantity_item.title',
                hidden: true
              },
              {
                title: 'SubscriptionQuantityItem Create',
                page: 'common/subscription_quantity_items/:id/new',
                translate: 'menu.common.subscription_quantity_item.create.title',
                hidden: true
              },
              {
                title: 'SubscriptionQuantityItem Edit',
                page: 'common/subscription_quantity_items/:id/edit',
                translate: 'menu.common.subscription_quantity_item.edit.title',
                hidden: true
              },
              {
                title: 'ProductPackageItem',
                page: 'common/product_package_items',
                translate: 'menu.common.product_package_item.title',
                hidden: true
              },
              {
                title: 'ProductPackageItem Create',
                page: 'common/product_package_items/:id/new',
                translate: 'menu.common.product_package_item.create.title',
                hidden: true
              },
              {
                title: 'ProductPackageItem Edit',
                page: 'common/product_package_items/:id/edit',
                translate: 'menu.common.product_package_item.edit.title',
                hidden: true
              },
              {
                title: 'ProductPackage',
                page: 'common/product_packages',
                translate: 'menu.common.product_package.title'
              },
              {
                title: 'ProductPackage Create',
                page: 'common/product_packages/:id/new',
                translate: 'menu.common.product_package.create.title',
                hidden: true
              },
              {
                title: 'ProductPackage Edit',
                page: 'common/product_packages/:id/edit',
                translate: 'menu.common.product_package.edit.title',
                hidden: true
              },
              {
                title: 'ProductCombo',
                page: 'common/product_combos',
                translate: 'menu.common.product_combo.title'
              },
              {
                title: 'ProductCombo Create',
                page: 'common/product_combos/:id/new',
                translate: 'menu.common.product_combo.create.title',
                hidden: true
              },
              {
                title: 'ProductCombo Edit',
                page: 'common/product_combos/:id/edit',
                translate: 'menu.common.product_combo.edit.title',
                hidden: true
              },
              {
                title: 'ProductComboItem',
                page: 'common/product_combo_items',
                translate: 'menu.common.product_combo_item.title',
                hidden: true
              },
              {
                title: 'ProductComboItem Create',
                page: 'common/product_combo_items/:id/new',
                translate: 'menu.common.product_combo_item.create.title',
                hidden: true
              },
              {
                title: 'ProductComboItem Edit',
                page: 'common/product_combo_items/:id/edit',
                translate: 'menu.common.product_combo_item.edit.title',
                hidden: true
              }
            ]
          },
          {
            title: 'ProductTag',
            page: 'common/product_tags',
            translate: 'menu.common.product_tag.title'
          },
          {
            title: 'ProductTag Create',
            page: 'common/product_tags/:id/new',
            translate: 'menu.common.product_tag.create.title',
            hidden: true
          },
          {
            title: 'ProductTag Edit',
            page: 'common/product_tags/:id/edit',
            translate: 'menu.common.product_tag.edit.title',
            hidden: true
          },
          {
            title: 'ProductOption',
            page: 'common/product_options',
            translate: 'menu.common.product_option.title'
          },
          {
            title: 'ProductOption Create',
            page: 'common/product_options/:id/new',
            translate: 'menu.common.product_option.create.title',
            hidden: true
          },
          {
            title: 'ProductOption Edit',
            page: 'common/product_options/:id/edit',
            translate: 'menu.common.product_option.edit.title',
            hidden: true
          },
          {
            title: 'ProductOption',
            translate: 'menu.common.product_option.title',
            page: 'common/product_options',
            hidden: true,
            submenu: [
              {
                title: 'ProductOptionItem',
                page: 'common/product_options/:parent_id/product_option_items',
                translate: 'menu.common.product_option_item.title'
              },
              {
                title: 'ProductOptionItem Create',
                page: 'common/product_options/:parent_id/product_option_items/:id/new',
                translate: 'menu.common.product_option_item.create.title',
                hidden: true
              },
              {
                title: 'ProductOptionItem Edit',
                page: 'common/product_options/:parent_id/product_option_items/:id/edit',
                translate: 'menu.common.product_option_item.edit.title',
                hidden: true
              }

            ]
          },
          {
            title: 'Product Management',
            bullet: 'line',
            translate: 'menu.common.promote.management.title',
            submenu: [
              {
                title: 'Promote',
                page: 'common/promotes',
                translate: 'menu.common.promote.title'
              },
              {
                title: 'Promote Create',
                page: 'common/promotes/:id/new',
                translate: 'menu.common.promote.create.title',
                hidden: true
              },
              {
                title: 'Promote Edit',
                page: 'common/promotes/:id/edit',
                translate: 'menu.common.promote.edit.title',
                hidden: true
              }
            ]
          }
        ]
      },
      {
        root: true,
        title: 'Common',
        icon: 'flaticon2-gear',
        translate: 'menu.common.title',
        bullet: 'line', // dot | lin
        submenu: [
          {
            title: 'Config',
            page: 'common/configs',
            translate: 'menu.common.config.title'
          },
          {
            title: 'Warehouse',
            page: 'common/warehouses',
            translate: 'menu.common.warehouse.title'
          },
          {
            title: 'Warehouse Create',
            page: 'common/warehouses/:id/new',
            translate: 'menu.common.warehouse.create.title',
            hidden: true
          },
          {
            title: 'Warehouse Edit',
            page: 'common/warehouses/:id/edit',
            translate: 'menu.common.warehouse.edit.title',
            hidden: true
          }
        ]
      },
      {
        root: true,
        title: 'Development',
        icon: 'flaticon2-gear',
        translate: 'menu.development.title',
        bullet: 'line', // dot | lin
        submenu: [
          {
            title: 'Base Data',
            bullet: 'line',
            translate: 'menu.dev.base.title',
            submenu: [
              {
                title: 'Supplier',
                page: 'erp/suppliers',
                translate: 'menu.erp.supplier.title'
              },
              {
                title: 'Supplier Create',
                page: 'erp/suppliers/:id/new',
                translate: 'menu.erp.supplier.create.title',
                hidden: true
              },
              {
                title: 'Supplier Edit',
                page: 'erp/suppliers/:id/edit',
                translate: 'menu.erp.supplier.edit.title',
                hidden: true
              },
              {
                title: 'SupplierContact',
                page: 'erp/supplier_contacts',
                translate: 'menu.erp.supplier_contact.title'
              },
              {
                title: 'SupplierContact Create',
                page: 'erp/supplier_contacts/:id/new',
                translate: 'menu.erp.supplier_contact.create.title',
                hidden: true
              },
              {
                title: 'SupplierContact Edit',
                page: 'erp/supplier_contacts/:id/edit',
                translate: 'menu.erp.supplier_contact.edit.title',
                hidden: true
              },
              {
                title: 'Customer',
                page: 'erp/customers',
                translate: 'menu.erp.customer.title'
              },
              {
                title: 'Customer Create',
                page: 'erp/customers/:id/new',
                translate: 'menu.erp.customer.create.title',
                hidden: true
              },
              {
                title: 'Customer Edit',
                page: 'erp/customers/:id/edit',
                translate: 'menu.erp.customer.edit.title',
                hidden: true
              },
              {
                title: 'CustomerContact',
                page: 'erp/customer_contacts',
                translate: 'menu.erp.customer_contact.title'
              },
              {
                title: 'CustomerContact Create',
                page: 'erp/customer_contacts/:id/new',
                translate: 'menu.erp.customer_contact.create.title',
                hidden: true
              },
              {
                title: 'CustomerContact Edit',
                page: 'erp/customer_contacts/:id/edit',
                translate: 'menu.erp.customer_contact.edit.title',
                hidden: true
              },
              {
                title: 'CustomerReceive',
                page: 'erp/customer_receives',
                translate: 'menu.erp.customer_receive.title'
              },
              {
                title: 'CustomerReceive Create',
                page: 'erp/customer_receives/:id/new',
                translate: 'menu.erp.customer_receive.create.title',
                hidden: true
              },
              {
                title: 'CustomerReceive Edit',
                page: 'erp/customer_receives/:id/edit',
                translate: 'menu.erp.customer_receive.edit.title',
                hidden: true
              },
              {
                title: 'ErpDepartment',
                page: 'erp/erp_departments',
                translate: 'menu.erp.erp_department.title'
              },
              {
                title: 'ErpDepartment Create',
                page: 'erp/erp_departments/:id/new',
                translate: 'menu.erp.erp_department.create.title',
                hidden: true
              },
              {
                title: 'ErpDepartment Edit',
                page: 'erp/erp_departments/:id/edit',
                translate: 'menu.erp.erp_department.edit.title',
                hidden: true
              },
              {
                title: 'Project',
                page: 'erp/projects',
                translate: 'menu.erp.project.title'
              },
              {
                title: 'Project Create',
                page: 'erp/projects/:id/new',
                translate: 'menu.erp.project.create.title',
                hidden: true
              },
              {
                title: 'Project Edit',
                page: 'erp/projects/:id/edit',
                translate: 'menu.erp.project.edit.title',
                hidden: true
              },
              {
                title: 'ProductUnit',
                page: 'erp/product_units',
                translate: 'menu.erp.product_unit.title'
              },
              {
                title: 'ProductUnit Create',
                page: 'erp/product_units/:id/new',
                translate: 'menu.erp.product_unit.create.title',
                hidden: true
              },
              {
                title: 'ProductUnit Edit',
                page: 'erp/product_units/:id/edit',
                translate: 'menu.erp.product_unit.edit.title',
                hidden: true
              }
            ]
          },
          {
            title: 'Inventory',
            bullet: 'line',
            translate: 'menu.dev.inventory.title',
            hidden: true,
            submenu: [
              {
                title: 'ErpProduct',
                page: 'erp/erp_products',
                translate: 'menu.erp.erp_product.title'
              },
              {
                title: 'ErpProduct Create',
                page: 'erp/erp_products/:id/new',
                translate: 'menu.erp.erp_product.create.title',
                hidden: true
              },
              {
                title: 'ErpProduct Edit',
                page: 'erp/erp_products/:id/edit',
                translate: 'menu.erp.erp_product.edit.title',
                hidden: true
              }
            ]
          },
          {
            title: 'Invoicing',
            bullet: 'line',
            translate: 'menu.dev.invoicing.title',
            submenu: [
              {
                title: 'Ordering',
                page: 'erp/orderings',
                translate: 'menu.erp.ordering.title'
              },
              {
                title: 'Ordering Create',
                page: 'erp/orderings/:id/new',
                translate: 'menu.erp.ordering.create.title',
                hidden: true
              },
              {
                title: 'Ordering Edit',
                page: 'erp/orderings/:id/edit',
                translate: 'menu.erp.ordering.edit.title',
                hidden: true
              },
              {
                title: 'OrderingItem',
                page: 'erp/ordering_items',
                translate: 'menu.erp.ordering_item.title',
                hidden: true
              },
              {
                title: 'OrderingItem Create',
                page: 'erp/ordering_items/:id/new',
                translate: 'menu.erp.ordering_item.create.title',
                hidden: true
              },
              {
                title: 'OrderingItem Edit',
                page: 'erp/ordering_items/:id/edit',
                translate: 'menu.erp.ordering_item.edit.title',
                hidden: true
              },
              {
                title: 'Sale',
                page: 'erp/sales',
                translate: 'menu.erp.sale.title'
              },
              {
                title: 'Sale Create',
                page: 'erp/sales/:id/new',
                translate: 'menu.erp.sale.create.title',
                hidden: true
              },
              {
                title: 'Sale Edit',
                page: 'erp/sales/:id/edit',
                translate: 'menu.erp.sale.edit.title',
                hidden: true
              },
              {
                title: 'SaleItem',
                page: 'erp/sale_items',
                translate: 'menu.erp.sale_item.title',
                hidden: true
              },
              {
                title: 'SaleItem Create',
                page: 'erp/sale_items/:id/new',
                translate: 'menu.erp.sale_item.create.title',
                hidden: true
              },
              {
                title: 'SaleItem Edit',
                page: 'erp/sale_items/:id/edit',
                translate: 'menu.erp.sale_item.edit.title',
                hidden: true
              },
              {
                title: 'Purchase',
                page: 'erp/purchases',
                translate: 'menu.erp.purchase.title'
              },
              {
                title: 'Purchase Create',
                page: 'erp/purchases/:id/new',
                translate: 'menu.erp.purchase.create.title',
                hidden: true
              },
              {
                title: 'Purchase Edit',
                page: 'erp/purchases/:id/edit',
                translate: 'menu.erp.purchase.edit.title',
                hidden: true
              },
              {
                title: 'PurchaseItem',
                page: 'erp/purchase_items',
                translate: 'menu.erp.purchase_item.title',
                hidden: true
              },
              {
                title: 'PurchaseItem Create',
                page: 'erp/purchase_items/:id/new',
                translate: 'menu.erp.purchase_item.create.title',
                hidden: true
              },
              {
                title: 'PurchaseItem Edit',
                page: 'erp/purchase_items/:id/edit',
                translate: 'menu.erp.purchase_item.edit.title',
                hidden: true
              }
            ]
          },
          {
            title: 'Account',
            bullet: 'line',
            translate: 'menu.dev.account.title',
            submenu: [
              {
                title: 'AccountTitle',
                page: 'erp/account_titles',
                translate: 'menu.erp.account_title.title'
              },
              {
                title: 'AccountTitle Create',
                page: 'erp/account_titles/:id/new',
                translate: 'menu.erp.account_title.create.title',
                hidden: true
              },
              {
                title: 'AccountTitle Edit',
                page: 'erp/account_titles/:id/edit',
                translate: 'menu.erp.account_title.edit.title',
                hidden: true
              },
              {
                title: 'AccountVoucher',
                page: 'erp/account_vouchers',
                translate: 'menu.erp.account_voucher.title'
              },
              {
                title: 'AccountVoucher Create',
                page: 'erp/account_vouchers/:id/new',
                translate: 'menu.erp.account_voucher.create.title',
                hidden: true
              },
              {
                title: 'AccountVoucher Edit',
                page: 'erp/account_vouchers/:id/edit',
                translate: 'menu.erp.account_voucher.edit.title',
                hidden: true
              },
              {
                title: 'AccountVouchersItem',
                page: 'erp/account_vouchers_items',
                translate: 'menu.erp.account_vouchers_item.title',
                hidden: true
              },
              {
                title: 'AccountVouchersItem Create',
                page: 'erp/account_vouchers_items/:id/new',
                translate: 'menu.erp.account_vouchers_item.create.title',
                hidden: true
              },
              {
                title: 'AccountVouchersItem Edit',
                page: 'erp/account_vouchers_items/:id/edit',
                translate: 'menu.erp.account_vouchers_item.edit.title',
                hidden: true
              },
              {
                title: 'Bank',
                page: 'erp/banks',
                translate: 'menu.erp.bank.title'
              },
              {
                title: 'Bank Create',
                page: 'erp/banks/:id/new',
                translate: 'menu.erp.bank.create.title',
                hidden: true
              },
              {
                title: 'Bank Edit',
                page: 'erp/banks/:id/edit',
                translate: 'menu.erp.bank.edit.title',
                hidden: true
              },
              {
                title: 'BankTran',
                page: 'erp/bank_trans',
                translate: 'menu.erp.bank_tran.title'
              },
              {
                title: 'BankTran Create',
                page: 'erp/bank_trans/:id/new',
                translate: 'menu.erp.bank_tran.create.title',
                hidden: true
              },
              {
                title: 'BankTran Edit',
                page: 'erp/bank_trans/:id/edit',
                translate: 'menu.erp.bank_tran.edit.title',
                hidden: true
              },
              {
                title: 'Check',
                page: 'erp/checks',
                translate: 'menu.erp.check.title'
              },
              {
                title: 'Check Create',
                page: 'erp/checks/:id/new',
                translate: 'menu.erp.check.create.title',
                hidden: true
              },
              {
                title: 'Check Edit',
                page: 'erp/checks/:id/edit',
                translate: 'menu.erp.check.edit.title',
                hidden: true
              },
              {
                title: 'CheckPayment',
                page: 'erp/check_payments',
                translate: 'menu.erp.check_payment.title'
              },
              {
                title: 'CheckPayment Create',
                page: 'erp/check_payments/:id/new',
                translate: 'menu.erp.check_payment.create.title',
                hidden: true
              },
              {
                title: 'CheckPayment Edit',
                page: 'erp/check_payments/:id/edit',
                translate: 'menu.erp.check_payment.edit.title',
                hidden: true
              },
              {
                title: 'AccountGeneral',
                page: 'erp/account_generals',
                translate: 'menu.erp.account_general.title'
              },
              {
                title: 'AccountGeneral Create',
                page: 'erp/account_generals/:id/new',
                translate: 'menu.erp.account_general.create.title',
                hidden: true
              },
              {
                title: 'AccountGeneral Edit',
                page: 'erp/account_generals/:id/edit',
                translate: 'menu.erp.account_general.edit.title',
                hidden: true
              }
            ]
          },
          {
            title: 'Invoice',
            bullet: 'line',
            translate: 'menu.dev.invoice.title',
            submenu: [
              {
                title: 'Invoice',
                page: 'erp/invoices',
                translate: 'menu.erp.invoice.title'
              },
              {
                title: 'Invoice Create',
                page: 'erp/invoices/:id/new',
                translate: 'menu.erp.invoice.create.title',
                hidden: true
              },
              {
                title: 'Invoice Edit',
                page: 'erp/invoices/:id/edit',
                translate: 'menu.erp.invoice.edit.title',
                hidden: true
              }
            ]
          }
        ]
      },
      {
        title: 'Report Manager',
        root: true,
        bullet: 'line',
        icon: 'flaticon2-browser-2',
        translate: 'menu.report.title',
        submenu: [
          {
            title: 'Report',
            page: 'erp/reports',
            translate: 'menu.erp.report.title'
          },
          {
            title: 'Report Sale',
            page: 'erp/reports/:code/:id/sale_reports',
            translate: 'menu.erp.report.sale_report.title',
            hidden: true
          },
          {
            title: 'Report Invoice',
            page: 'erp/reports/:code/:id/invoice_reports',
            translate: 'menu.erp.report.invoice_report.title',
            hidden: true
          }
        ]
      },
      {
        section: 'Product',
        translate: 'menu.section.product.title'
      },
      { section: 'Reference' },
      {
        root: true,
        title: 'Documentation',
        bullet: 'line',
        icon: 'flaticon2-file-1',
        submenu: [
          { title: 'Quick Start', page: 'docs/quick-start' },
          { title: 'Overview', page: 'docs/overview' },
          { title: 'Deployment', page: 'docs/deployment' },
          { title: 'Internationalization', page: 'docs/i18n' },
          { title: 'Mock Backend', page: 'docs/mock-backend' },
          { title: 'Create a Page', page: 'docs/create-a-page' }
        ]
      },
      {
        title: 'Layout Builder',
        root: true,
        icon: 'flaticon2-expand',
        page: 'builder'
      },
      {
        title: 'Material UI',
        root: true,
        bullet: 'line',
        icon: 'flaticon2-browser-2',
        submenu: [
          {
            title: 'Layout',
            bullet: 'line',
            submenu: [
              {
                title: 'Box',
                page: 'google-material/layout/box'
              },
              {
                title: 'Container',
                page: 'google-material/layout/container'
              },
              {
                title: 'Grid',
                page: 'google-material/layout/grid'
              },
              {
                title: 'Grid list',
                page: 'google-material/layout/grid-list'
              },
              {
                title: 'Hidden',
                page: 'google-material/layout/hidden'
              }
            ]
          },
          {
            title: 'Inputs',
            bullet: 'line',
            submenu: [
              {
                title: 'Autocomplete',
                page: 'google-material/inputs/autocomplete',
                permission: 'accessToECommerceModule'
              },
              {
                title: 'Buttons',
                page: 'google-material/inputs/buttons'
              },
              {
                title: 'Checkboxes',
                page: 'google-material/inputs/checkboxes'
              },
              {
                title: 'Pickers',
                page: 'google-material/inputs/pickers'
              },
              {
                title: 'Radio Buttons',
                page: 'google-material/inputs/radio-buttons'
              },
              {
                title: 'Selects',
                page: 'google-material/inputs/selects'
              },
              {
                title: 'Switches',
                page: 'google-material/inputs/switches'
              },
              {
                title: 'Text Fields',
                page: 'google-material/inputs/text-fields'
              },
              {
                title: 'Transfer List',
                page: 'google-material/inputs/transfer-list'
              }
            ]
          },
          {
            title: 'Navigation',
            bullet: 'line',
            submenu: [
              {
                title: 'Bottom Navigation',
                page: 'google-material/navigation/bottom-navigation'
              },
              {
                title: 'Breadcrumbs',
                page: 'google-material/navigation/breadcrumbs'
              },
              {
                title: 'Drawers',
                page: 'google-material/navigation/drawer'
              },
              {
                title: 'Links',
                page: 'google-material/navigation/links'
              },
              {
                title: 'Menus',
                page: 'google-material/navigation/menus'
              },
              {
                title: 'Steppers',
                page: 'google-material/navigation/steppers'
              },
              {
                title: 'Tabs',
                page: 'google-material/navigation/tabs'
              }
            ]
          },
          {
            title: 'Surfaces',
            bullet: 'line',
            submenu: [
              {
                title: 'App Bar',
                page: 'google-material/surfaces/app-bar'
              },
              {
                title: 'Paper',
                page: 'google-material/surfaces/paper'
              },
              {
                title: 'Cards',
                page: 'google-material/surfaces/cards'
              },
              {
                title: 'Expansion Panels',
                page: 'google-material/surfaces/expansion-panels'
              }
            ]
          },
          {
            title: 'Feedback',
            bullet: 'line',
            submenu: [
              {
                title: 'Progress',
                page: 'google-material/feedback/progress'
              },
              {
                title: 'Dialogs',
                page: 'google-material/feedback/dialogs'
              },
              {
                title: 'Snackbars',
                page: 'google-material/feedback/snackbars'
              }
            ]
          },
          {
            title: 'Data Display',
            bullet: 'line',
            submenu: [
              {
                title: 'Avatars',
                page: 'google-material/data-displays/avatars'
              },
              {
                title: 'Badges',
                page: 'google-material/data-displays/badges'
              },
              {
                title: 'Chips',
                page: 'google-material/data-displays/chips'
              },
              {
                title: 'Dividers',
                page: 'google-material/data-displays/dividers'
              },
              {
                title: 'Icons',
                page: 'google-material/data-displays/icons'
              },
              {
                title: 'Lists',
                page: 'google-material/data-displays/lists'
              },
              {
                title: 'Tables',
                page: 'google-material/data-displays/tables'
              },
              {
                title: 'Tooltips',
                page: 'google-material/data-displays/tooltips'
              },
              {
                title: 'Typography',
                page: 'google-material/data-displays/typography'
              }
            ]
          },
          {
            title: 'Utils',
            bullet: 'line',
            submenu: [
              {
                title: 'Click Away Listener',
                page: 'google-material/utils/click-away-listener'
              },
              {
                title: 'Modal',
                page: 'google-material/utils/modal'
              },
              {
                title: 'No SSR',
                page: 'google-material/utils/no-ssr'
              },
              {
                title: 'Popover',
                page: 'google-material/utils/popover'
              },
              {
                title: 'Popper',
                page: 'google-material/utils/popper'
              },
              {
                title: 'Portal',
                page: 'google-material/utils/portal'
              },
              {
                title: 'Transitions',
                page: 'google-material/utils/transitions'
              },
              {
                title: 'useMediaQuery',
                page: 'google-material/utils/use-media-query'
              }
            ]
          }
        ]
      },
      {
        title: 'Bootstrap',
        root: true,
        bullet: 'line',
        icon: 'flaticon2-digital-marketing',
        submenu: [
          {
            title: 'Alerts',
            page: 'react-bootstrap/alert'
          },
          {
            title: 'Accordion',
            page: 'react-bootstrap/accordion'
          },
          {
            title: 'Badge',
            page: 'react-bootstrap/badge'
          },
          {
            title: 'Breadcrumb',
            page: 'react-bootstrap/breadcrumb'
          },
          {
            title: 'Buttons',
            page: 'react-bootstrap/buttons'
          },
          {
            title: 'Button Group',
            page: 'react-bootstrap/button-group'
          },
          {
            title: 'Cards',
            page: 'react-bootstrap/cards'
          },
          {
            title: 'Carousel',
            page: 'react-bootstrap/carousel'
          },
          {
            title: 'Dropdowns',
            page: 'react-bootstrap/dropdowns'
          },
          {
            title: 'Forms',
            page: 'react-bootstrap/forms'
          },
          {
            title: 'Input Group',
            page: 'react-bootstrap/input-group'
          },
          {
            title: 'Images',
            page: 'react-bootstrap/images'
          },
          {
            title: 'Figures',
            page: 'react-bootstrap/figures'
          },
          {
            title: 'Jumbotron',
            page: 'react-bootstrap/jumbotron'
          },
          {
            title: 'List group',
            page: 'react-bootstrap/list-group'
          },
          {
            title: 'Modal',
            page: 'react-bootstrap/modal'
          },
          {
            title: 'Navs',
            page: 'react-bootstrap/navs'
          },
          {
            title: 'Navbar',
            page: 'react-bootstrap/navbar'
          },
          {
            title: 'Overlays',
            page: 'react-bootstrap/overlays'
          },
          {
            title: 'Pagination',
            page: 'react-bootstrap/pagination'
          },
          {
            title: 'Popovers',
            page: 'react-bootstrap/popovers'
          },
          {
            title: 'Progress',
            page: 'react-bootstrap/progress'
          },
          {
            title: 'Spinners',
            page: 'react-bootstrap/spinners'
          },
          {
            title: 'Table',
            page: 'react-bootstrap/table'
          },
          {
            title: 'Tabs',
            page: 'react-bootstrap/tabs'
          },
          {
            title: 'Tooltips',
            page: 'react-bootstrap/tooltips'
          },
          {
            title: 'Toasts',
            page: 'react-bootstrap/toasts'
          }
        ]
      },
      {
        title: 'Error Pages',
        root: true,
        bullet: 'line',
        icon: 'flaticon-danger',
        submenu: [
          {
            title: 'Error Page - 1',
            page: 'error/error-v1'
          },
          {
            title: 'Error Page - 2',
            page: 'error/error-v2'
          },
          {
            title: 'Error Page - 3',
            page: 'error/error-v3'
          },
          {
            title: 'Error Page - 4',
            page: 'error/error-v4'
          },
          {
            title: 'Error Page - 5',
            page: 'error/error-v5'
          },
          {
            title: 'Error Page - 6',
            page: 'error/error-v6'
          }
        ]
      }
    ]
  }
}
